import React, { h } from 'preact'
import { Box } from './box'
import { SearchIcon } from './search-icon'

import style from './input.css'

interface Props {
    onInput?: (value: string) => void
    placeholder: string
}

export const Input: React.FunctionalComponent<Props> = ({
    onInput,
    placeholder,
}) => {
    const handleInput: React.JSX.GenericEventHandler<HTMLInputElement> = (
        event
    ): void => {
        onInput(event.currentTarget.value)
    }
    return (
        <Box position="relative">
            <input
                onInput={handleInput}
                placeholder={placeholder}
                className={style.input}
            ></input>
            <SearchIcon className={style.searchIcon} />
        </Box>
    )
}
